// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"632c7566","247":"c53ecfcf","422":"2377dbeb","551":"c6059c46","627":"5058ec2b","731":"686b8fa3","834":"ca4e4d61","842":"cc34a5a5","849":"53c10c80","867":"68d0e043","923":"f2a58aef","938":"cd6bdd66"}[chunkId] + ".chunk.js";
};